import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CallTypes from './components/CallTypes';
import Niches from './components/Niches';
import Process from './components/Process';
import CallMetrics from './components/CallMetrics';
import Testimonials from './components/Testimonials';
import ContactCTA from './components/ContactCTA';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-slate-950 font-sans selection:bg-indigo-500/30 overflow-x-hidden">
      <Navbar />
      <Hero />
      <CallTypes />
      <Niches />
      <Process />
      <CallMetrics />
      <Testimonials />
      <ContactCTA />
      <Footer />
    </div>
  );
}

export default App;